import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import theme from '@/style';
import {useMemo} from 'react';
import {StyleSheet} from 'react-native';
import {invitationColors} from './invitation.variables';

function useSize() {
  const {screenWidth, screenHeight, designWidth, calcActualSize} =
    useScreenSize();
  const pageHorizontalPadding = calcActualSize(12);
  const invitationCodeCardImgWidth = screenWidth - 2 * pageHorizontalPadding;
  const invitationCodeCardImgHeight = (invitationCodeCardImgWidth / 343) * 64;
  const size = useMemo(() => {
    return {
      screenWidth,
      screenHeight,
      designWidth,
      calcActualSize,
      pageHorizontalPadding,
      invitationCodeCardImgWidth,
      invitationCodeCardImgHeight,
    };
  }, [
    screenWidth,
    screenHeight,
    designWidth,
    calcActualSize,
    pageHorizontalPadding,
    invitationCodeCardImgWidth,
    invitationCodeCardImgHeight,
  ]);
  return size;
}

export function useInnerStyle() {
  const size = useSize();

  const whiteSpaceStyle = StyleSheet.create({
    bottom: {
      paddingBottom: 72,
    },
  });

  const ruleStyle = StyleSheet.create({
    tableItem: {
      width: 100,
    },
    tableDataRow: {
      height: 40,
    },
    contentWrap: {
      borderWidth: 2,
      borderColor: theme.basicColor.primary,
    },
    contentItem: {
      width: (311 * size.screenWidth) / size.designWidth,
    },
  });

  const navHeight = 52;

  const homeStyle = StyleSheet.create({
    nav: {
      // 目前暂不考虑覆盖状态栏的情况
      height: navHeight,
    },
    navFloat: {
      zIndex: 1,
    },
    navOverlay: {
      top: 0,
      left: 0,
      zIndex: 2,
    },
    bg: {
      top: size.calcActualSize(-44),
      left: 0,
    },
    scrollView: {
      flex: 1,
    },
    pagePadding: {
      paddingHorizontal: size.pageHorizontalPadding,
    },
    resetLink: {
      height: size.calcActualSize(28),
      backgroundColor: '#FFEFEF',
      borderRadius: size.calcActualSize(4),
    },
    codeTitle: {
      height: size.calcActualSize(36),
    },
    codeCardRow: {
      height: size.invitationCodeCardImgHeight,
      paddingLeft: size.calcActualSize(12),
      paddingRight: size.calcActualSize(32),
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    codeValueBox: {
      width: size.calcActualSize(193),
      height: size.calcActualSize(52),
      backgroundColor: theme.basicColor.white,
      paddingLeft: size.calcActualSize(16),
      paddingRight: size.calcActualSize(16),
      paddingTop: size.calcActualSize(6),
      paddingBottom: size.calcActualSize(6),
    },
    codeCopyBtn: {
      width: size.calcActualSize(84),
      minWidth: size.calcActualSize(84),
      height: size.calcActualSize(32),
      borderRadius: size.calcActualSize(20),
      paddingHorizontal: size.calcActualSize(8),
      paddingVertical: size.calcActualSize(4),
    },
    contentContainer: {
      paddingTop: size.calcActualSize(164),
    },
    contentInner: {
      borderRadius: 8,
      overflow: 'hidden',
    },
    infoUpItem: {
      borderBottomWidth: 1,
      borderBottomColor: invitationColors.line,
      paddingBottom: theme.paddingSize.m,
      marginBottom: theme.paddingSize.l,
    },
    infoUpSubItemRight: {
      borderLeftWidth: 1,
      borderLeftColor: invitationColors.line,
      paddingLeft: theme.paddingSize.l,
    },
    infoBottomText: {
      width: 80,
    },
    bounsTitle: {
      height: 40,
      borderBottomWidth: 1,
      borderBottomColor: invitationColors.line,
    },
    bounsBody: {
      paddingTop: theme.paddingSize.m,
      paddingBottom: theme.paddingSize.m,
    },
    bounsUpItem: {
      height: 28,
      backgroundColor: invitationColors.bounsItem,
      borderRadius: 2,
    },
    bounsCirclesContainer: {
      height: 0,
    },
    bounsCircle: {
      width: 14,
      height: 14,
      borderRadius: 7,
    },
    bounsCircleLeft: {
      left: -7,
      top: -7,
    },
    bounsCircleRight: {
      right: -7,
      top: -7,
    },
    bonusButton: {
      height: 40,
      borderRadius: 40,
      marginTop: 4,
    },
    statisticItem: {
      width: 120,
      height: 42,
    },
  });

  const recordModalStyle = StyleSheet.create({
    container: {
      height: 500,
    },
    header: {
      paddingHorizontal: theme.paddingSize.m * 2,
      paddingTop: theme.paddingSize.m * 2,
    },
    error: {
      height: 300,
    },
    item: {
      borderBottomWidth: 1,
      borderColor: invitationColors.line,
    },
    bottom: {
      paddingHorizontal: theme.paddingSize.l * 2,
      paddingBottom: theme.paddingSize.l * 2,
    },
    button: {
      height: 40,
      backgroundColor: theme.backgroundColor.main,
      borderRadius: 28,
    },
  });

  return {
    size,
    whiteSpaceStyle,
    ruleStyle,
    homeStyle,
    recordModalStyle,
  };
}
